import {ChangeDetectionStrategy, Component, computed, inject} from '@angular/core';
import {SidenavService} from '@app-layout/sidenav/data-access';
import {AuthStore} from '@auth/data-access';
import {CompanySettingsStore} from '@company-settings/data-access';
import {IconComponent} from '@shared/icon';
import {StoredFile} from '@global-data';
import {hostBinding} from 'ngxtension/host-binding';

@Component({
	selector: 'dc-sidenav-header',
	imports: [IconComponent],
	templateUrl: './sidenav-header.component.html',
	styleUrls: ['./sidenav-header.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidenavHeaderComponent {
	$hostCollapsed = hostBinding(
		'class.collapsed',
		computed(() => this.isCollapsed$()),
	);

	protected readonly isCollapsed$ = computed(() => this.sidenavService.collapsed());

	private readonly sidenavService = inject(SidenavService);
	protected readonly authStore = inject(AuthStore);

	protected readonly companySettingsStore = inject(CompanySettingsStore);
	protected readonly companyLogo$ = computed(() => {
		const companyLogo = this.companySettingsStore.state()?.settings?.companyLogo;
		if (companyLogo?.data) {
			return new StoredFile(companyLogo.data, companyLogo.type);
		}
		return null;
	});

	constructor() {}

	protected toggleSidenav(): void {
		this.sidenavService.toggleCollapsed();
		this.sidenavService.saveToLocalStorage();
	}
}
